var map = {
	"./01-01.mp3": 487,
	"./01-01__.mp3": 761,
	"./01-02.mp3": 762,
	"./01-03.mp3": 353,
	"./01-04.mp3": 354,
	"./01-05.mp3": 488,
	"./01-06.mp3": 763,
	"./01-07.mp3": 764,
	"./01-08.mp3": 765,
	"./01-09.mp3": 766
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1457;